import { createContext } from 'react'

export type PartnerOffersBadgeValue = {
  /** null = jeszcze nieznane; false = moduł wyłączony na backendzie (404). */
  enabled: boolean | null
  count: number
  ordersCount: number
  /** null = nieznane; false = orders-enabled wyłączone (404) — chowamy zlecenia/rozliczenia. */
  ordersEnabled: boolean | null
  refresh: () => void
}

export const defaultPartnerOffersBadgeValue: PartnerOffersBadgeValue = {
  enabled: null,
  count: 0,
  ordersCount: 0,
  ordersEnabled: null,
  refresh: () => undefined,
}

export const PartnerOffersBadgeContext = createContext<PartnerOffersBadgeValue>(
  defaultPartnerOffersBadgeValue
)
